import { Component, OnInit, Input } from '@angular/core';
import { ProveedorService } from '../../../services/proveedor.service';
import * as Chart from 'chart.js';
import * as numeral from 'numeral';

@Component({
    selector: 'chart-proveedores-mas-compras',
    templateUrl: './proveedores-mas-compras.component.html',
    styleUrls: ['./proveedores-mas-compras.component.css'],
    providers: [ProveedorService]
})

export class ProveedoresMasComprasComponent implements OnInit {
    @Input() periodo: String;
    @Input() fecha_inicio;
    @Input() fecha_fin;
    public loading: boolean;
    public data: Array<any>;
    private myChart: any;

    constructor(
        private proveedorService: ProveedorService,
    ) {
        this.loading = false;
        this.data = [];
    }

    ngOnInit() {
        this.initChart();
    }

    initChart(periodo?) {
        this.periodo = periodo ? periodo : this.periodo;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(parseFloat(e.valor).toFixed(2));
                    labels.push(e.nombre_comercial);
                });

                this.drawChart(data, labels);
                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    getData() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.periodo == "otro") {
                qs = "?periodo=" + this.periodo + "&fecha_inicio=" + this.fecha_inicio + "&fecha_fin=" + this.fecha_fin;
            } else {
                qs = "?periodo=" + this.periodo;
            }


            this.proveedorService.getMasCompras(qs).subscribe(
                res => {
                    this.data = res.data;
                    resolve(true);
                },
                err => {
                    this.data = [];
                    reject(err);
                }
            );


        });
    }

    updateDataChart(periodo, fecha_inicio, fecha_fin) {
        this.periodo = periodo ? periodo : this.periodo;
        this.fecha_inicio = fecha_inicio ? fecha_inicio : this.fecha_inicio;
        this.fecha_fin = fecha_fin ? fecha_fin : this.fecha_fin;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(parseFloat(e.valor).toFixed(2));
                    labels.push(e.nombre_comercial);
                });

                //this.drawChart(data, labels);
                this.myChart.data.datasets[0].data = data;
                this.myChart.data.labels = labels;
                this.myChart.update();

                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    drawChart(data, labels) {
        var ctx = document.getElementById("cvsProveedoresImportantes");

        this.myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: [
                        '#7baaf7',
                        '#57bb8a',
                        '#80deea',
                        '#80cbc4',
                        '#e6ee9c',
                    ],
                    borderColor: [
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                    ],
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                legend: {
                    position: 'top'
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        //title: function (tooltipItem, data) {
                        //    return "Día " + data.labels[tooltipItem[0].index]; 
                        //},
                        label: function(tooltipItems, data) {
                            return "$ " + numeral(data.datasets[0].data[tooltipItems.index]).format('0,0.00');
                        },
                        footer: function (tooltipItem, data) {
                            let total = 0;
                            data.datasets[0].data.forEach(value => total += parseFloat(value));
                            let porcent = (parseFloat(data.datasets[0].data[tooltipItem[0].index]) / total) * 100;
                            return numeral(porcent).format('0,0.00') + " %";
                        }
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/charts/proveedores-mas-compras/proveedores-mas-compras.component.ts